import { memo } from "react";

import cc from "classcat";
import { useLocalization } from "@fluent/react";
import { modules } from "byzantine";

import styles from "./MenuItem.module.scss";

interface SidebarAOIOBItemProps {
  title: string;
  isVisible?: boolean;
}

const SidebarAOIOBItem = ({ title, isVisible }: SidebarAOIOBItemProps) => {
  const { l10n } = useLocalization();
  const { fetchAoiobLink } = modules.aoiob.useFetchAoiobLink();

  const subItemContainerClass = cc([
    styles["icon-title-container"],
    styles.hover,
    styles["menu-item-text"],
  ]);

  const handleClick = () => {
    fetchAoiobLink({
      onSuccess: ({ link }: { link: string }) => {
        const success = window.open(link, "_blank", "noopener");
        if (success === null) {
          // TODO: Add notification support when cerulean is available
          console.error(
            l10n.getString(
              "services-item-open-an-account-popup-failed-error",
              null,
              "We cannot open the application. Please adjust your browser's pop-up settings."
            )
          );
        }
      },
    });
  };

  return (
    <button
      className={subItemContainerClass}
      title={title}
      onClick={handleClick}
      role="menuitem"
      tabIndex={isVisible ? 0 : -1}
    >
      <span>{title}</span>
    </button>
  );
};

export default memo(SidebarAOIOBItem);
